import * as React from 'react';
import { Component, RefObject } from 'react';
import { ButtonTertiary, MeatballMenu, PromptConfirmationModal } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { CodetableTranslation } from '../../constants';

import styles from './codetable-sticky-header.scss';
import { CodeActionType, ReadOnlyConfiguration } from 'app/area/indicator-factors/item/types';
import { CodeItem } from 'app/area/indicator-factors/item/types-store';
import { CodetableMetadata } from 'app/area/indicator-factors/types-store';
import { SaveButton } from 'app/area/indicator-factors/item/sticky-header/save-button';
import { replaceTemplateString } from 'app/infrastructure/platform';

export interface CodetableStickyHeaderProps {
  codetableId: number;
  codeItem: CodeItem;
  breadcrumbs: number[];
  codeId: number;
  codetableName: string;
  actionType: CodeActionType;
  translation: CodetableTranslation;
  longDescription?: string;
  readOnlyConfig: ReadOnlyConfiguration;
  metadata: CodetableMetadata;
  shouldPrompt: boolean;
  save: () => void;
  cancel: () => void;
  deleteCodeItem: () => void;
  duplicateCodeItem: () => void;
}

export class IndicatorFactorsStickyHeader extends Component<CodetableStickyHeaderProps> {

  private longDescriptionRef: RefObject<HTMLDivElement | null> = React.createRef<HTMLDivElement>();

  public render() {
    const {
      codetableId, codeItem, codetableName, longDescription, actionType, codeId, translation,
      save, cancel, deleteCodeItem, duplicateCodeItem, readOnlyConfig, shouldPrompt
    } = this.props;

    return (
      <StickyHeader rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary id={`codetable-sticky-header-cancel-button-${codetableId}`} onClick={cancel}>
            {translation.cancel}
          </ButtonTertiary>
          <SaveButton
            codetableId={codetableId}
            actionType={actionType}
            readOnlyConfig={readOnlyConfig}
            shouldPrompt={shouldPrompt}
            translation={translation}
            save={save} />
        </StickyHeaderButtonContainer>
        {!!codeId && codeId > 0 && actionType !== CodeActionType.Duplicate && (duplicateCodeItem || deleteCodeItem)
          && <MeatballMenu id="codetable-sticky-header-meatballmenu">
            {duplicateCodeItem && <li>
              <button type="button" className="dropdown-item" onClick={duplicateCodeItem}>
                {!!translation && translation.duplicate_code}
              </button>
            </li>}
            {deleteCodeItem && <li>
              <PromptConfirmationModal
                title={translation.delete_code_item_title}
                description={
                  replaceTemplateString(
                    translation.delete_confirm,
                    [
                      codeItem?.substance?.description,
                      codeItem?.substanceUom?.description,
                      codeItem?.indicatorSubstance?.description,
                      codeItem?.indicatorSubstanceUom?.description,
                      codeItem?.indicatorType?.description
                    ].join(', ')
                  )}
                continueText={translation.delete_code_item_title}
                cancelText={translation.cancel}
                onContinue={deleteCodeItem}>
                <button type="button" className="dropdown-item">
                  {!!translation && translation.delete}
                </button>
              </PromptConfirmationModal>
            </li>}
          </MeatballMenu>}
      </>}>
        <div className={styles.title}>{codetableName}</div>
        <div className={styles.actionTitleContainer}>
          <h2 className={styles.actionTitle}>
            {actionType === CodeActionType.Edit
              ? '#' + codeId
              : (actionType === CodeActionType.Add ? translation.new_code_item : translation.duplicate_code_item)}
          </h2>
        </div>
        {!!longDescription
          ? <div className={`${styles.longDescriptionContainer} ${!!longDescription ? '' : styles.hiddenLongDescriptionContainer}`}>
            <div id="codetable-sticky-header-long-description" className={styles.longDescription} ref={this.longDescriptionRef}>
              {longDescription}
            </div>
          </div>
          : null
        }
      </StickyHeader>
    );
  }
}
